function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBathroom = function SvgBathroom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.7,
    height: 16.7
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M432.283 654.25h7.467l-.472 2.716a4.22 4.22 0 0 1-4.209 3.416h-6.638a4.22 4.22 0 0 1-4.209-3.416l-.472-2.716h3.2",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".7px"
    },
    transform: "translate(-423.4 -644.032)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.849 657.86h-4.088a.51.51 0 0 1-.511-.511v-3.577a1.023 1.023 0 0 1 1.022-1.022h3.066a1.02 1.02 0 0 1 1.022 1.022v3.577a.51.51 0 0 1-.511.511",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".7px"
    },
    transform: "translate(-424.633 -643.554)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.75 642.794a2.044 2.044 0 1 1 4.088 0v7.154",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".7px"
    },
    transform: "translate(-427.51 -640.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.75 645.794a2.044 2.044 0 1 1 4.088 0z",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".7px"
    },
    transform: "translate(-426.737 -641.356)"
  }));
};
export { SvgBathroom as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi43IiBoZWlnaHQ9IjE2LjciIHZpZXdCb3g9IjAgMCAxNi43IDE2LjciPgogICAgPHBhdGggIGQ9Ik00MzIuMjgzIDY1NC4yNWg3LjQ2N2wtLjQ3MiAyLjcxNmE0LjIxOCA0LjIxOCAwIDAgMS00LjIwOSAzLjQxNmgtNi42MzhhNC4yMTggNC4yMTggMCAwIDEtNC4yMDktMy40MTZsLS40NzItMi43MTZoMy4yIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDIzLjQgLTY0NC4wMzIpIiBzdHlsZT0iZmlsbDpub25lO3N0cm9rZTojMzMzO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6LjdweCIvPgogICAgPHBhdGggIGQ9Ik00MzIuODQ5IDY1Ny44NmgtNC4wODhhLjUxMS41MTEgMCAwIDEtLjUxMS0uNTExdi0zLjU3N2ExLjAyMyAxLjAyMyAwIDAgMSAxLjAyMi0xLjAyMmgzLjA2NmExLjAyMiAxLjAyMiAwIDAgMSAxLjAyMiAxLjAyMnYzLjU3N2EuNTExLjUxMSAwIDAgMS0uNTExLjUxMXoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00MjQuNjMzIC02NDMuNTU0KSIgc3R5bGU9ImZpbGw6bm9uZTtzdHJva2U6IzMzMztzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLXdpZHRoOi43cHgiLz4KICAgIDxwYXRoICBkPSJNNDM4Ljc1IDY0Mi43OTRhMi4wNDQgMi4wNDQgMCAxIDEgNC4wODggMHY3LjE1NCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQyNy41MSAtNjQwLjQpIiBzdHlsZT0iZmlsbDpub25lO3N0cm9rZTojMzMzO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6LjdweCIvPgogICAgPHBhdGggIGQ9Ik00MzUuNzUgNjQ1Ljc5NGEyLjA0NCAyLjA0NCAwIDEgMSA0LjA4OCAweiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQyNi43MzcgLTY0MS4zNTYpIiBzdHlsZT0iZmlsbDpub25lO3N0cm9rZTojMzMzO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6LjdweCIvPgo8L3N2Zz4K";